<template>
  <b-container>
    <b-row class="text-left">
      <b-col cols="auto" class="login card">
        <h2 class="title">Login</h2>
        <b-row class="mt-4 mb-4">
          <b-col>
            <!-- <button class="ms-button" @click="loginMS()">
              <img style="float: left;" src="/assets/microsoft-icon.png">Sign in with Microsoft
            </button> -->
            <button class="ms-button" @click="loginMS()">
              <img style="float: left;" src="/assets/microsoft-icon.png">Sign in with Microsoft
            </button>
          </b-col>
        </b-row>
        <b-row class="text-center" style="color: #333333">
          <b-col>
            <strong>Or</strong>
            <hr>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-form @submit.prevent="handleSubmit">
              <b-form-group
                label="Email"
                label-for="email"
              >
                <b-form-input
                  id="email"
                  type="text"
                  v-model="email"
                  required
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="Password"
                label-for="password"
              >
                <b-form-input
                  id="password"
                  type="password"
                  v-model="password"
                  required
                  :state="passwordState === '' ? null : false"
                  :invalid-feedback="passwordState"
                  :description="passwordState"
                ></b-form-input>
                <div class="invalid-feedback">{{passwordState}}</div>
              </b-form-group>
              <b-link class="btn-tertiary" to="/password/forgot"><p>Forgot Password?</p></b-link>
              <div class="form-group">
                <b-row>
                  <b-col>
                    <b-button type="submit" variant="primary" :disabled="loading" style="width: 100%">
                      <div v-if="!loading">
                        Login
                      </div>
                      <b-spinner small v-if="loading" label="Spinning"></b-spinner>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </b-form>
          </b-col>
        </b-row>
        <BaseMessageBlock :messages="errors"></BaseMessageBlock>
        <BaseMessageBlock :messages="messages" type="Success"></BaseMessageBlock>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import authMixin from "@/mixins/auth-mixin.js";

export default {
  mixins: [authMixin],
  data() {
    return {
      email: "",
      password: "",
      passwordState: "",
      errors: [],
      messages: [],
      loading: false,
      submitted: false,
      nextUrl: null,

      projectId: null
    };
  },
  mounted() {
    this.projectId = localStorage.getItem('tempProjectId')

    this.nextUrl = this.$route.query.returnUrl || this.$store.getters.getReturnUrl;
    if (this.user != null) {

      if (this.authenticated) {
        if (this.projectId) {
          let url = `${this.$api_url}/users/${this.user.userId}/permissions`
          axios
            .get(url, this.getReqConfig())
            .then(res => {
              let permissions = res.data.userAccount.projectPermissions
              let project = permissions.find(p => p.id == this.projectId)

              if (!project) {
                let userId = res.data.userAccount.userId
                let query = {
                  uid: userId,
                };

                this.$router.push({ name: "Account Setup", query: query });
              } else {
                this.defaultRedirect(this.nextUrl);
              }
            })
        } else {
          this.defaultRedirect(this.nextUrl);
        }
      } else if (this.$store.getters.getPauseAuth === true) {
        this.logout();
        //To DO: why?
      }
    }

    if (this.$store.getters.getAuthError) {
      this.errors.push({ message: this.$store.getters.getAuthError });

      //Remove from storage after being displayed
      // this.$store.dispatch('setAuthError', "");
    }
    if (this.$route.query.message) {
      this.messages.push({ message: this.$route.query.message });
    }

    if (this.$route.query.error) {
      this.errors.push({ message: this.$route.query.error });
    }

    if (this.$route.query.signed_up) {
      this.messages.push({ message: "You're all set!"});
      this.messages.push({ message: "Be on the lookout for your monthly project surveys."});
      this.messages.push({ message: '<a href="https://support.microsoft.com/en-ie/office/add-recipients-of-my-email-messages-to-the-safe-senders-list-be1baea0-beab-4a30-b968-9004332336ce">For best results, add info@dashtech.app to your safe senders list.</a>'});
    }

    if (this.$route.query.autoLogin) {
      this.email = localStorage.getItem("tempEmail");
      this.password = localStorage.getItem("tempPass");

      localStorage.removeItem("tempEmail");
      localStorage.removeItem("tempPass");

      this.handleSubmit();
    }
  },
  methods: {
    loginMS(){
      this.$store.dispatch('setAuthError', "");
      if (this.nextUrl) {
        this.$store.dispatch('setReturnUrl', this.nextUrl);
      }
      this.errors = [];

      this.$authService.msal.setActiveAccount(null);
      this.$authService.signIn()
        .then(async (response) => {
          await this.setupAuth(response);
          this.defaultRedirect(this.nextUrl);
        });
    },
    handleSubmit() {
      this.$store.dispatch('setAuthError', "");
      this.passwordState = "";
      if (!this.$validate.isValidPassword(this.password)) {
        this.passwordState = "Password must be at least 6 characters long, have at least 1 lowercase letter, at least 1 uppercase letter, at least 1 number, and at least 1 non-alphanumeric character";
        return;
      }

      this.errors = [];
      this.messages = [];

      this.loading = true;
      axios
        .post(`${this.$api_url}/identity/login`, {
          email: this.email,
          password: this.password
        }, this.getReqConfig())
        .then(async (response) => {
          await this.initDashTechSession(response.data);
          
          if (this.projectId) {
            let userId = response.data.userAccount.userId
            let userEmail = response.data.userAccount.email
            let url = `${this.$api_url}/users/${userEmail}/permissions`

            axios
              .get(url, this.getReqConfig())
              .then(async res => {
                let permissions = res.data.userAccount.projectPermissions
                let project = permissions.find(p => p.id == this.projectId)

                if (!project) {
                  let query = {
                    uid: userId,
                  };

                  this.defaultRedirect({ name: "Account Setup", query: query });
                } else {
                  this.defaultRedirect(this.nextUrl);
                }
              })
              .catch(err => {
                this.errors.push(...this.$helpers.formatErrors(err));
              })
          } else {
            this.defaultRedirect(this.nextUrl);
          }
        })
        .catch(err => {
          this.errors.push(...this.$helpers.formatErrors(err));
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    isAdmin() {
      let user = this.accountUser;
      return user != null && user.admin;
    },
    isSponsor() {
      let user = this.accountUser;
      return user != null && user.sponsor;
    },
    user() {
      return this.accountUser;
    },
    authError() {
      return this.$store.getters.getAuthError;
    }
  },
  watch: {
    authError(val) {
      if (val) {
        this.errors = [{ message: val }];
      }
    },
    authenticated(val) {
      if (val && this.user != null) {
        this.defaultRedirect(this.nextUrl);
      }
    },
    user(val) {
      if (val != null && this.authenticated) {
        this.defaultRedirect(this.nextUrl);
      }
    }
  }
};
</script>

<style>
.ms-button {
  font-family: "Segoe UI"; 
  font-size: 15px; 
  font-weight: 600; 
  color: #5E5E5E; 
  background-color: #FFFFFF; 
  border: 1.5px solid #8C8C8C; 
  height: 41px; 
  width: 100%; 
  padding: 0 12px;
}
.login{
  padding: 25px;
  margin: 50px auto 0 auto;
  border: none;
  max-width: 90%;
  width: 400px;
}
</style>